export default "__VITE_ASSET__876bcf02__"